import React from 'react'
import { FaPhone, FaEnvelope, FaSkype, FaMapMarkerAlt, FaGithub } from 'react-icons/fa'
import data from '../../data.json'

const Footer = () => {
  return (
    <div className="mt-[1px] w-full items-center justify-between bg-black/80 p-5 text-white lg:px-[100px]">
      <div className="mx-auto max-w-[900px] 2xl:max-w-[1185px]">
        <div className="flex flex-col gap-y-4 text-sm md:flex-row md:justify-between">
          <div className="">
            <div className="mb-1 text-center text-base font-bold">Address</div>
            <div className="flex justify-center">
              <div className="">
                <div className="flex w-40 items-center gap-1">
                  <FaMapMarkerAlt className="h-[16px] w-[16px]" />
                  {data.liveLocation}
                </div>
              </div>
            </div>
          </div>
          <div className="">
            <div className="mb-1 text-center text-base font-bold">Online Profiles</div>
            <div className="flex justify-center">
              <div>
                <div className="flex items-center gap-1">
                  <FaGithub />
                  <a href={data.github} rel="noreferrer" target="_blank">
                    {data.github}
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="">
            <div className="mb-1 text-center text-base font-bold">Contact</div>
            <div className="flex justify-center">
              <div className="flex flex-col gap-y-1">
                {/* <div className="flex items-center gap-1">
                  <FaPhone />
                  <a rel="noreferrer" target="_blank">
                    {data.phone}
                  </a>
                </div> */}
                <div className="flex items-center gap-1">
                  <FaEnvelope />
                  <a href={`mailto:${data.email}`} rel="noreferrer" target="_blank">
                    {data.email}
                  </a>
                </div>
                <div className="flex items-center gap-1">
                  <FaSkype />
                  <a href="skype:live:.cid.cbca59438f0dca4a?chat" rel="noreferrer" target="_blank">
                    live:.cid.cbca59438f0dca4a
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Footer
